<template>
  <div class="management-warpper">
    <div class="bg-white margin-bottom-sm">
      <twoLevel @SearchInfo="SearchInfo"/>
    </div>
    <div class="bg-white margin-bottom-sm">
      <h3 class="management-title">重要提醒</h3>
      <div class="flex align-center justify-between">
        <div class="remind-item" @click="toList(1)">
          <img src="../../assets/img/remind-icon1.png" alt="">
          <div class="flex-sub">
            生日
            <i>{{ shengRiCount }}</i>
          </div>
        </div>
        <div class="remind-item" @click="toList(2)">
          <img src="../../assets/img/remind-icon2.png" alt="">
          <div class="flex-sub">
            退休
            <i>{{ tuiXiuCount }}</i>
          </div>
        </div>
        <div class="remind-item" @click="toList(3)">
          <img src="../../assets/img/remind-icon3.png" alt="">
          <div class="flex-sub">
            新生儿
            <i>{{ xinShengErCount }}</i>
          </div>
        </div>
        <div class="remind-item" @click="toList(4)">
          <img src="../../assets/img/remind-icon4.png" alt="">
          <div class="flex-sub">
            入托
            <i>{{ ruTuoCount }}</i>
          </div>
        </div>
        <div class="remind-item" @click="toList(5)">
          <img src="../../assets/img/remind-icon5.png" alt="">
          <div class="flex-sub">
            入学
            <i>{{ ruXueCount }}</i>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white margin-bottom-sm">
      <h3 class="management-title">社区统计</h3>
      <div class="flex align-center justify-between">
        <div class="statistics-item">
          <img src="../../assets/img/remind-icon6.png" alt="">
          <div>
            <p>楼栋数</p>
            <h3>{{ louDongCount }}</h3>
          </div>
        </div>
        <div class="statistics-item">
          <img src="../../assets/img/remind-icon7.png" alt="">
          <div>
            <p>总户数</p>
            <h3>{{ zongHuCount }}</h3>
          </div>
        </div>
        <div class="statistics-item">
          <img src="../../assets/img/remind-icon8.png" alt="">
          <div>
            <p>已退休</p>
            <h3>{{ yiTuiXiu }}</h3>
          </div>
        </div>
        <!--        <div class="statistics-item">-->
        <!--          <img src="../../assets/img/remind-icon9.png" alt="">-->
        <!--          <div>-->
        <!--            <p>外籍人数</p>-->
        <!--            <h3>18</h3>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="statistics-item">
          <img src="../../assets/img/remind-icon10.png" alt="">
          <div>
            <p>社区总人数</p>
            <h3>{{ sheQuZongRenCount }}</h3>
          </div>
        </div>
        <div class="statistics-item">
          <img src="../../assets/img/remind-icon11.png" alt="">
          <div>
            <p>空房数</p>
            <h3>{{ kongFangCount }}</h3>
          </div>
        </div>

      </div>
    </div>

    <div class="bg-white margin-bottom-sm flex align-center justify-between">
      <div class="management-item management-item1">
        <div class="management-item-left">
          <img src="../../assets/img/management-icon1.png" alt="">
          <h3>新签物业合同</h3>
        </div>
        <div class="management-item-right">
          <div>
            <p>已签署份数</p>
            <h3>{{ yiQianWuYeHeTong }}</h3>
          </div>
          <div>
            <p>占比</p>
            <h3>{{ yiQianShuBiLv }}%</h3>
          </div>
        </div>
      </div>
      <div class="management-item management-item2">
        <div class="management-item-left">
          <img src="../../assets/img/management-icon2.png" alt="">
          <h3>物业费统计</h3>
        </div>
        <div class="management-item-right">
          <div>
            <p>新收费用</p>
            <h3>{{xinZengWuYeFei}}</h3>
          </div>
          <div>
            <p>年度应收</p>
            <h3>{{ nianDuWuYeYingShou }}</h3>
          </div>
          <div>
            <p>年度实收</p>
            <h3>{{ nianDuWuYeShiShou }}</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white">
      <journal/>
    </div>
  </div>
</template>

<script>
import twoLevel from '@/components/two-level'
import journal from '@/components/journal'
import {wuYeGuanLi} from "@/api/statistics";
import {zhRmb} from "@/utils/utils";

export default {
  name: "property-management",
  data() {
    return {
      kongFangCount: 0,
      louDongCount: 0,
      nianDuWuYeShiShou: 0,
      nianDuWuYeYingShou: 0,
      ruTuoCount: 0,
      ruXueCount: 0,
      sheQuZongRenCount: 0,
      shengRiCount: 0,
      tuiXiuCount: 0,
      xinShengErCount: 0,
      xinZengWuYeFei: 0,
      yiQianShuBiLv: 0,
      yiQianWuYeHeTong: 0,
      yiTuiXiu: 0,
      zongHuCount: 0,
      project:0,
      community:0,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "物业管理", false);
  },
  components: {
    twoLevel,
    journal
  },
  methods: {
    async SearchInfo(val) {
      this.project = val.project
      this.community = val.community
      let _data = await wuYeGuanLi(
          val.project,
          val.community
      )
      this.kongFangCount = _data.data.kongFangCount
      this.louDongCount = _data.data.louDongCount
      this.nianDuWuYeShiShou = zhRmb(_data.data.nianDuWuYeShiShou)
      this.nianDuWuYeYingShou = zhRmb(_data.data.nianDuWuYeYingShou)
      this.ruTuoCount = _data.data.ruTuoCount
      this.ruXueCount = _data.data.ruXueCount
      this.sheQuZongRenCount = _data.data.sheQuZongRenCount
      this.shengRiCount = _data.data.shengRiCount
      this.tuiXiuCount = _data.data.tuiXiuCount
      this.xinShengErCount = _data.data.xinShengErCount
      this.xinZengWuYeFei = zhRmb(_data.data.xinZengWuYeFei)
      this.yiQianShuBiLv = (_data.data.yiQianShuBiLv*100).toFixed(2)
      this.yiQianWuYeHeTong = _data.data.yiQianWuYeHeTong
      this.yiTuiXiu = _data.data.yiTuiXiu
      this.zongHuCount = _data.data.zongHuCount
    },
    toList(num){
      this.$router.push('/home/resident-data?tips=' + num + '&project='+this.project+'&community='+this.community)
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.management-warpper {
  .management-title {
    font-size: 16px;
    position: relative;
    padding-left: 10px;
    margin-bottom: 20px;

    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      width: 6px;
      height: 17px;
      background-color: #d00000;
    }
  }

  .remind-item {
    display: flex;
    align-items: center;
    flex-basis: 19%;
    height: 100px;
    padding: 15px 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 19px 0px rgba(175, 181, 193, 0.47);
    border-radius: 10px;
    position: relative;

    img {
      width: 66px;
      height: 66px;
      background-image: linear-gradient(0deg,
          #e92f2f 0%,
          #fd6b6b 100%);
      box-shadow: 0px 3px 8px 0px rgba(234, 50, 50, 0.35);
      border-radius: 20px;
    }

    div {

      height: 60px;
      line-height: 60px;
      font-size: 20px;
      margin-left: 20px;

      i {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 0 8px;
        height: 26px;
        line-height: 26px;
        background-color: #ff8400;
        border-radius: 13px;
        color: #fff;
        font-size: 16px;
      }
    }
  }

  .statistics-item {
    display: flex;
    align-items: center;
    padding: 20px 0;

    img {
      display: block;
      width: 59px;
      height: 59px;
      border-radius: 16px;
      margin-right: 10px;
    }

    div {
      padding-right: 10px;

      p {
        line-height: 24px;
        font-size: 16px;
        color: #666666;
      }

      h3 {
        font-size: 26px;
        line-height: 36px;
      }
    }
  }

  .management-item {
    flex-basis: 49%;
    height: 162px;
    padding: 20px;
    display: flex;
    align-items: center;

    &.management-item1 {
      background: url(../../assets/img/management-bg1.png) no-repeat;
      background-size: 100% 100%;
    }

    &.management-item2 {
      background: url(../../assets/img/management-bg2.png) no-repeat;
      background-size: 100% 100%;
    }

    .management-item-left {
      width: 200px;

      img {
        display: block;
        width: 50px;
        margin: 0 auto 15px;
      }

      h3 {
        color: #fff;
        font-size: 28px;
        text-align: center;
      }
    }

    .management-item-right {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex: 1;

      div {
        p {
          font-size: 16px;
          line-height: 24px;
          color: #fff;
        }

        h3 {
          font-size: 28px;
          line-height: 36px;
          color: #fff;
        }
      }
    }
  }
}
</style>
